import { connect } from "react-redux"
import { Map } from "immutable"

import {
    communityParticipantListRequest,
    communityParticipantListSearchRequest
} from "../../../../../actions/community-participant-actions"

import CommunityViewParticipants from "./CommunityViewParticipants"

const participantTypes = [
    { label: "Members", value: "members" },
    { label: "Managers", value: "managers" },
    { label: "Followers", value: "followers" },
    { label: "Invitation sent", value: "invited" },
    { label: "Awaiting approval", value: "awaitingApproval" }
]

const mapStateToProps = ({ presentation: { communities }, paging }, props) => {
    const participantPaging =
        paging.communityParticipants[communities.selectedParticipantType]
    const pagingRequest =
        participantPaging[
            communities[`${communities.selectedParticipantType}SearchCriteria`]
        ] || {}
    return {
        selectedParticipantType: communities.selectedParticipantType,
        participantTypes,
        searchTerm: communities.participantSearchTerm,
        pagingRequest,
        ...props
    }
}

const mapDispatchToProps = (dispatch, { communityId }) => ({
    onTypeChange: pagingRequest => ({ target }) =>
        dispatch(communityParticipantListRequest(target.value, pagingRequest)),
    onSearch: ({ target }) => {
        dispatch(
            communityParticipantListSearchRequest(
                Map({
                    name: target.value,
                    communityId
                })
            )
        )
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(
    CommunityViewParticipants
)
